interface Props {
  [key: string]: any
}

function ExpandArrowsIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 8 8" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M7.43248 7.33482H5.83901M1.05859 2.55441V0.960938V2.55441ZM1.05859 0.960938H2.65207H1.05859ZM1.05859 0.960938L3.05043 2.95278L1.05859 0.960938ZM7.43248 2.55441V0.960938V2.55441ZM7.43248 0.960938H5.83901H7.43248ZM7.43248 0.960938L5.44064 2.95278L7.43248 0.960938ZM1.05859 5.74135V7.33482V5.74135ZM1.05859 7.33482H2.65207H1.05859ZM1.05859 7.33482L3.05043 5.34298L1.05859 7.33482ZM7.43248 7.33482L5.44064 5.34298L7.43248 7.33482ZM7.43248 7.33482V5.74135V7.33482Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.832146"
      />
    </svg>
  )
}

export default ExpandArrowsIcon
